<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getAdminSettings, updateAdminSettings, ApiError, type AdminSettings } from '@/api'

const { t } = useI18n()
const adminSettings = ref<AdminSettings | null>(null)
const adminSettingsSaving = ref(false)
const adminSettingsError = ref('')

async function loadAdminSettings() {
  adminSettingsError.value = ''
  try {
    adminSettings.value = await getAdminSettings()
  } catch (e) {
    adminSettingsError.value = e instanceof ApiError ? e.message : t('admin.settings.loadFailed')
  }
}

async function toggleVerboseSync() {
  if (!adminSettings.value) return
  adminSettingsSaving.value = true
  adminSettingsError.value = ''
  try {
    adminSettings.value = await updateAdminSettings({ verbose_sync_enabled: !adminSettings.value.verbose_sync_enabled })
  } catch (e) {
    adminSettingsError.value = e instanceof ApiError ? e.message : t('admin.settings.updateFailed')
  } finally {
    adminSettingsSaving.value = false
  }
}

onMounted(loadAdminSettings)
</script>

<template>
  <p v-if="adminSettingsError" class="error">{{ adminSettingsError }}</p>
  <template v-if="adminSettings">
    <label class="checkbox-label">
      <input type="checkbox" :checked="adminSettings.verbose_sync_enabled" :disabled="adminSettingsSaving" @change="toggleVerboseSync" />
      {{ t('admin.settings.verboseSync') }}
    </label>
    <p class="hint">{{ t('admin.settings.verboseSyncHint') }}</p>
  </template>
</template>

<style scoped>
.hint {
  color: var(--tg-hint-color);
  font-size: 0.85rem;
}

.error {
  color: var(--tg-destructive-text-color);
}
</style>
